'use client';

import { simpleDatalistSection } from '@stereoagency/sanity-schema';
import { SimpleDatalistSection as UISimpleDatalistSection } from '@stereoagency/ui';
import flush from 'just-flush';
import { SimpleBlockContent } from '../sanity/client';

type Props = typeof simpleDatalistSection.schema.simpleDatalistSection;

export default function SimpleDatalistSection({ title, description, rows }: Props) {
  if (!rows?.length) {
    return null;
  }

  return (
    <UISimpleDatalistSection
      title={title}
      description={
        description ? <SimpleBlockContent value={description} /> : null
      }
      entries={flush(
        rows.map((row) => {
          if (!row.title || !row.values?.length) return null;
          return {
            label: row.title,
            values: row.values
          };
        })
      )}
    />
  );
}
